import { BaseComponent } from '@/src/app/shared/components/base-component/base.component';
import {
  DataTableDataProvider,
  GenericDataTableDataProvider
} from '@/src/app/shared/modules/general-commons/components/data-table/data-table-data-provider';
import { FileUtils } from '@/src/app/utils/file.utils';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { SearchFilterService } from '../../../search/services/search-filter.service';
import { PractitionerSearchModel } from '../../models/practitioner-search.model';
import { PractitionerService } from '../../practitioner.service';
import { WsHelperService } from '@shared/services/ws-helper.service';
import { GlobalErrorHandlerService } from '@shared/services/global-error-handler.service';
import { GenericWidePageComponent } from '@shared/modules/general-commons/components/generic-page-wide/generic-wide-page.component';
import { PageHeaderComponent } from '@shared/modules/general-commons/components/page-header/page-header.component';
import { PractitionerSearchComponent } from '../practitioner-search/practitioner-search.component';
import { DataTableComponent } from '@shared/modules/general-commons/components/data-table/data-table.component';
import { MatRowDef, MatRow } from '@angular/material/table';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'stx-practitioner-search-page',
  templateUrl: './practitioner-search-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [SearchFilterService],
  imports: [
    GenericWidePageComponent,
    PageHeaderComponent,
    PractitionerSearchComponent,
    DataTableComponent,
    MatRowDef,
    MatRow,
    TranslateModule
  ]
})
export class PractitionerSearchPageComponent extends BaseComponent implements OnInit {
  private practitionerService = inject(PractitionerService);
  private searchFilterService = inject(SearchFilterService);
  private readonly wsHelperService = inject(WsHelperService);
  private globalErrorHandlerService = inject(GlobalErrorHandlerService);

  searchResultsDataProvider: DataTableDataProvider<any>;
  private searchFilters: PractitionerSearchModel;
  constructor() {
    super();
    const practitionerService = this.practitionerService;
    const wsHelperService = this.wsHelperService;
    const globalErrorHandlerService = this.globalErrorHandlerService;

    this.searchResultsDataProvider = new GenericDataTableDataProvider(
      {
        loadFunction: pageSort => wsHelperService.callWithSpinner(practitionerService.getPractitioners(pageSort, this.searchFilters))
      },
      wsHelperService,
      globalErrorHandlerService
    );
  }

  ngOnInit(): void {
    this.subSink.sink = this.searchFilterService.searchEvent$.subscribe((searchFilters: PractitionerSearchModel) => {
      this.searchFilters = searchFilters;
      this.searchResultsDataProvider.reload();
    });

    this.subSink.sink = this.searchFilterService.csvDownloadEvent$.subscribe((searchFilters: PractitionerSearchModel) => {
      this.wsHelperService.call(this.practitionerService.getPractitionersCsvFile(searchFilters)).subscribe(res => {
        FileUtils.downloadFile(res, 'STX-practitioners.csv');
      });
    });
  }
}
